import React from "react";
import { ReactComponent as EyeOpenIcon } from "@zendeskgarden/svg-icons/src/16/eye-stroke.svg";

type Props = React.SVGProps<SVGSVGElement>;

export const EyeClosedIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    focusable="false"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="none" stroke="currentColor" strokeLinecap="round">
      <path d="M.58 8.29c.7 1 3.28 4.21 7.42 4.21s6.72-3.21 7.42-4.21" />
      <path d="M8 12.5v2M3.9 11.6l-1.3 1.6M12.1 11.6l1.3 1.6" />
    </g>
  </svg>
);

export { EyeOpenIcon };

interface PasswordVisibilityIconProps extends Props {
  visible: boolean;
  onToggle: (visible: boolean) => void;
}

const PasswordVisibilityIcon = ({
  visible,
  onToggle,
  ...props
}: PasswordVisibilityIconProps) => {
  const Icon = visible ? EyeOpenIcon : EyeClosedIcon;
  return (
    <Icon
      style={{ cursor: "pointer" }}
      onClick={() => onToggle(!visible)}
      {...props}
    />
  );
};

export default PasswordVisibilityIcon;
